"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRewardRateDescription = exports.getRecommendedCreditScoreFormattedDetails = exports.getIntroOfferValueTooltip = exports.getIntroOfferValue = exports.isChase = exports.isDiscover = exports.isAnnualFeeWaivedForFirstYear = exports.getMinCreditScoreBucket = exports.getMaxCreditScoreBucket = exports.getBucketFromScore = exports.ficoMap = exports.BucketName = void 0;

var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _lowerCase2 = _interopRequireDefault(require("lodash/lowerCase"));

var _creditCards = require("../selectors/credit-cards");

var _constants = require("../constants");

/**
@enum BucketName
*/
var BucketName = {
  user: 'user',
  poor: 'poor',
  average: 'average',
  good: 'good',
  excellent: 'excellent'
}; // This is where we define bounds for each bucket

exports.BucketName = BucketName;
var ficoMap = {
  poor: {
    min: 300,
    max: 629
  },
  average: {
    min: 630,
    max: 689
  },
  good: {
    min: 690,
    max: 719
  },
  excellent: {
    min: 720,
    max: 850
  }
};
/**
Given a score, returns the bucket name the score falls into
@param {number} - credit score to be tested
@returns {BucketName} - name of the bucket which score falls into
*/

exports.ficoMap = ficoMap;

var getBucketFromScore = function getBucketFromScore(score) {
  if (score >= ficoMap.excellent.min) {
    return BucketName.excellent;
  }

  if (score >= ficoMap.good.min) {
    return BucketName.good;
  }

  if (score >= ficoMap.average.min) {
    return BucketName.average;
  }

  return BucketName.poor;
};
/**
 * Get the associated bucket name for the maximum FICO score (eg. 800 => 'excellent').
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 * @return     {string}  The bucket name.
 */


exports.getBucketFromScore = getBucketFromScore;

var getMaxCreditScoreBucket = function getMaxCreditScoreBucket(marketplaceEntity) {
  return getBucketFromScore((0, _creditCards.getMaximumFICO)(marketplaceEntity));
};
/**
 * Get the associated bucket name for the minimum FICO score (eg. 800 => 'excellent').
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 * @return     {string}  The bucket name.
 */


exports.getMaxCreditScoreBucket = getMaxCreditScoreBucket;

var getMinCreditScoreBucket = function getMinCreditScoreBucket(marketplaceEntity) {
  return getBucketFromScore((0, _creditCards.getMinimumFICO)(marketplaceEntity));
};
/**
 * Returns true if the annual fee is waived for the first year, false otherwise.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 * @return     {bool}    Whether or not the annual fee is waived for the first year.
 */


exports.getMinCreditScoreBucket = getMinCreditScoreBucket;

var isAnnualFeeWaivedForFirstYear = function isAnnualFeeWaivedForFirstYear(marketplaceEntity) {
  return (0, _creditCards.getAnnualFee)(marketplaceEntity) > 0 && (0, _creditCards.getAnnualFeeFirstYear)(marketplaceEntity) === 0;
};
/**
 * Whether the offer is a discover.
 * @param {object} offer - The CC offer.
 * @returns {boolean}
 */


exports.isAnnualFeeWaivedForFirstYear = isAnnualFeeWaivedForFirstYear;

var isDiscover = function isDiscover(offer) {
  return (0, _lowerCase2.default)((0, _creditCards.getIssuerName)(offer)) === 'discover';
};
/**
 * Whether the offer is a chase.
 * @param {object} offer - The CC offer.
 * @returns {boolean}
 */


exports.isDiscover = isDiscover;

var isChase = function isChase(offer) {
  return (0, _lowerCase2.default)((0, _creditCards.getIssuerName)(offer)) === 'chase';
};
/**
 * Returns `value` field to be used in the Intro Offer Quick Fact.
 * @param {object} offer - The CC entity.
 * @returns {(string | number)} - The sign up bonus details annotation, or the sign up bonus value.
 */


exports.isChase = isChase;

var getIntroOfferValue = function getIntroOfferValue(offer) {
  var signUpBonusDetailsAnnotation = (0, _creditCards.getSignUpBonusDetailsAnnotation)(offer);

  if (signUpBonusDetailsAnnotation) {
    return signUpBonusDetailsAnnotation;
  }

  var signUpBonus = (0, _creditCards.getSignUpBonus)(offer);
  var signUpBonusType = (0, _creditCards.getSignUpBonusType)(offer);
  /**
   * Display N/A only if the sign_up_bonus_type is null or "NO REWARDS"
   * and signup_bonus is 0, for all other sign_up_bonus_types, 0 is a valid value.
   */

  if (((0, _isNil2.default)(signUpBonusType) || signUpBonusType === _constants.CREDIT_CARDS_REWARD_TYPES.NO_REWARDS) && signUpBonus === 0) return 'N/A';
  return signUpBonus;
};
/**
 * Returns `valueTooltip` field to be used in the Intro Offer Quick Fact.
 * @param {object} offer - The CC offer.
 * @returns {string}
 */


exports.getIntroOfferValue = getIntroOfferValue;

var getIntroOfferValueTooltip = function getIntroOfferValueTooltip(offer) {
  return (0, _creditCards.getSignUpBonus)(offer) ? (0, _creditCards.getSignUpBonusDetails)(offer) : null;
};
/**
 * Get the recommended credit score range text.
 * @param {object}  offer  The CC offer.
 * @return {object} - The credit score range & description.
 * @property {string} creditScoreRange
 * @property {string} creditScoreRangeDescription
 */


exports.getIntroOfferValueTooltip = getIntroOfferValueTooltip;

var getRecommendedCreditScoreFormattedDetails = function getRecommendedCreditScoreFormattedDetails(offer) {
  var minCreditScoreIndex = (0, _creditCards.getMinimumFICO)(offer);
  var maxCreditScoreIndex = (0, _creditCards.getMaximumFICO)(offer);
  var maxCreditScoreRange = (0, _capitalize2.default)(getMaxCreditScoreBucket(offer));
  var minCreditScoreRange = (0, _capitalize2.default)(getMinCreditScoreBucket(offer));
  var creditScoreRange = minCreditScoreIndex === maxCreditScoreIndex ? minCreditScoreIndex : "".concat(minCreditScoreIndex, "-").concat(maxCreditScoreIndex);
  var creditScoreRangeDescription = maxCreditScoreRange === minCreditScoreRange ? minCreditScoreRange : "".concat(minCreditScoreRange, " - ").concat(maxCreditScoreRange);
  return {
    creditScoreRange: creditScoreRange,
    creditScoreRangeDescription: creditScoreRangeDescription
  };
};
/**
 * Get the reward type description.
 * @param   {Object}  offer  The CC offer.
 * @returns {string} - The reward rate description.
 */


exports.getRecommendedCreditScoreFormattedDetails = getRecommendedCreditScoreFormattedDetails;

var getRewardRateDescription = function getRewardRateDescription(offer) {
  var rewardRateType = (0, _creditCards.getRewardRateType)(offer);
  var rewardType = (0, _creditCards.getRewardType)(offer);
  /**
   * Return `Cashback` denomination when reward rate type value is percent
   * with reward type as cash.
   */

  if (rewardRateType === _constants.CREDIT_CARDS_REWARD_RATE_TYPES.PERCENT && rewardType === _constants.CREDIT_CARDS_REWARD_TYPES.CASH) {
    return 'Cashback';
  }

  return _constants.CREDIT_CARDS_REWARD_TYPE_DESCRIPTIONS[rewardType] || null;
};

exports.getRewardRateDescription = getRewardRateDescription;